import React, { useEffect, useState } from 'react';
import './surveyPdf.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import surveyService from '../../features/survey/surveyService';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';


function SurveyPdf() {

    // let districtId = useParams().districtId;
    // let authorization = useParams().token

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // console.log('queryParams', queryParams);
    // Retrieve specific query parameters  
    const role = queryParams.get('role');
    const districtId = queryParams.get('districtId');
    const authorization = queryParams.get('token');


    // console.log('districtId', districtId);
    // console.log('auth', authorization);

    const [surveydata, setSurveyData] = useState([]);
    const [nextSurveydata, setNextSurveyData] = useState([]);

    const [distName, setDistName] = useState('')
    let [isLoading, setIsLoading] = useState(false);
    let [isPageLoad, setisPageLoad] = useState(false);


    useEffect(() => {
        setIsLoading(true);
        surveyService.getSurveyDataPdf(districtId, authorization).then((response) => {

            var outArr = response.data.surveyPageData

            for (let i = 0; i < outArr.length; i++) {
                let filteredArr = outArr[i].schoolSurveyData.filter(f => {
                    let arr = f.moduleData.map((g) => {
                        if (g.value == 1) return g
                    })
                    arr = arr.filter(a => {
                        return a
                    })
                    f['checkArr'] = arr
                    return f['checkArr'].length > 0
                })
                outArr[i].schoolSurveyData = filteredArr
            }

            var obj = response.data.surveyPageData

            var transformedArr = [];

            for (var i = 0; i < obj.length; i++) {
                var surveyType = obj[i].name; // Get the survey type (e.g., "Elementary Survey" or "Middle School Survey")

                for (var j = 0; j < obj[i].schoolSurveyData.length; j++) {
                    var schoolData = obj[i].schoolSurveyData[j]; // Get the school survey data

                    var transformedSchoolData = {
                        "schoolId": schoolData.schoolId,
                        "name": schoolData.name,
                        "ncesId": schoolData.ncesId,
                        "surveyType": surveyType
                    };

                    for (var k = 0; k < schoolData.moduleData.length; k++) {
                        var module = schoolData.moduleData[k];
                        transformedSchoolData[module.shortCode] = module.value; // Add module data with shortCode as key
                    }

                    transformedSchoolData["blockData"] = schoolData.blockData;
                    transformedSchoolData["tupe"] = schoolData.tupe;
                    transformedSchoolData["closeData"] = schoolData.closeData;
                    transformedArr.push(transformedSchoolData);
                }
            }


            console.log(transformedArr);

            let firstArr = transformedArr.slice(0, 20)
            let secondArr = transformedArr.slice(20, transformedArr.length)
            secondArr = _.chunk(secondArr, 20)

            setSurveyData(firstArr);
            setNextSurveyData(secondArr)
            setDistName(response.data.distName)

            setIsLoading(false)
            setisPageLoad(true)
        }).catch(err => {
            console.log("err", err);
        })
    }, []);


    const surveyTypeOptions = ['Core', 'BHM', 'SCM', 'SEHM', 'Well', 'TIP', 'CHM', 'CSCH', 'CTAG', 'DFC',
        'LGBTQ', 'MHS', 'TUPE', 'DASM', 'GRAM', 'Mil', 'RYDM', 'SafeV', 'SexB', 'Tob', 'HLTH', 'SpED', 'Cust']

    const TableRowStyledSurveyPdf = styled(TableRow)`
         &:nth-of-type(odd) {
           background-color: #EEEEEE;
           border-right : 1px solid #FFFFFF;
         }
    `;

    return (
        <>

            <div className='pdfSurvey_pageHeader'>

                <div id="pdfImage"><img alt="Delete School" src={require("../../assets/images/menuHeader.png")} className="pdfSurvey_logoSize"></img></div>

                <div className="pdfSurvey_ImageSub">CalSCHLS Coordinator Portal</div>

                <div className="pdfSurvey_country">{distName ? distName : ''}</div>
                <div className="pdfSurvey_pgTitle">SURVEY MODULE SELECTION</div>

            </div>

            <div className='survey_pageContent_survey_pdf'>
                <div>
                    <TableContainer>
                        <Table >
                            <TableHead>
                                <TableRow className='headerStyle'>
                                    <TableCell
                                        ref={el => {
                                            if (el) {
                                                el.style.setProperty('width', '6%', 'important');
                                            }
                                        }}
                                        style={{ width: '6%' }} className='schoolHeaderSurveyPdf'>Survey Type</TableCell>
                                    <TableCell
                                        ref={el => {
                                            if (el) {
                                                el.style.setProperty('width', '60%', 'important');
                                            }
                                        }}
                                        style={{ minWidth: '6%' }} className='schoolHeaderSurveyPdf'>School Name</TableCell>
                                    <TableCell style={{ width: '4%' }} className='schoolHeaderSurveyPdf'>School ID</TableCell>
                                    {surveyTypeOptions.map(headers => (
                                        <TableCell style={{ width: '3%' }} className='schoolHeaderSurveyPdf'>{headers}</TableCell>
                                    ))}

                                    {role == 'admin' ?

                                        <>
                                            <TableCell
                                                ref={el => {
                                                    if (el) {
                                                        el.style.setProperty('width', '1%', 'important');
                                                    }
                                                }}
                                                className="schoolHeaderSurveyPdf">Blocks</TableCell>
                                            <TableCell style={{ width: '3%' }} className="schoolHeaderSurveyPdf">Tupe</TableCell>
                                            <TableCell style={{ width: '4%' }} className="schoolHeaderSurveyPdf">Closed</TableCell>
                                        </>
                                        : ''
                                    }
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {surveydata && surveydata.map((data) => (

                                    <TableRowStyledSurveyPdf>

                                        <TableCell
                                            // ref={el => {
                                            //     if (el) {
                                            //         el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                            //     }
                                            // }}
                                            className='schoolBodySurveyPdf'> {data.surveyType}
                                        </TableCell>

                                        <TableCell
                                            // ref={el => {

                                            //     if (el) {
                                            //         el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                            //     }
                                            // }} 
                                            className='schoolBodySurveyPdf'>{data.name}
                                        </TableCell>

                                        <TableCell
                                            ref={el => {

                                                if (el) {
                                                    el.style.setProperty('padding', '4px 10px 10px 4px', 'important');
                                                }
                                            }}
                                            className='schoolBodySurveyPdf'>{data.ncesId}
                                        </TableCell>

                                        {surveyTypeOptions.map(surveyOptionsheader => (

                                            <TableCell className='schoolBodySurveyPdf'>
                                                {Object.keys(data).map(e => (
                                                    <>
                                                        {e == surveyOptionsheader ?
                                                            data[e] == 1 ?
                                                                <img className='imageCheckSurveyPdf' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check'></img>
                                                                : ''
                                                            : ''}

                                                    </>
                                                ))}
                                            </TableCell>
                                        ))}

                                        {role == 'admin' ?

                                            <>
                                                <TableCell className='schoolBodySurveyPdf' >
                                                    {data.blockData.length > 0 ?
                                                        <>
                                                            <span style={{ fontSize: '13px' }} className='imageCheckSurveyPdf'>{data.blockData.sort().join(',')}</span>
                                                        </> : ''}
                                                </TableCell>

                                                <TableCell className='schoolBodySurveyPdf'>
                                                    {data.tupe == 0 ? ''
                                                        : <img className='imageCheckSurveyPdf' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check'></img>
                                                    }
                                                </TableCell>

                                                <TableCell className='schoolBodySurveyPdf'>
                                                    {data.closeData == 0 ? ''
                                                        : <img className='imageCheckSurveyPdf' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check'></img>
                                                    }
                                                </TableCell>

                                            </> : ''}

                                    </TableRowStyledSurveyPdf>

                                ))}

                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

            {nextSurveydata && nextSurveydata.map(inData => (
                <>

                    <div className='survey_pageContent_survey_pdf_next'>
                        <div>
                            <TableContainer>
                                <Table >
                                    <TableHead>
                                        <TableRow className='headerStyle'>
                                            <TableCell style={{ width: '8%' }} className='schoolHeaderSurveyPdf'>Survey Type</TableCell>
                                            <TableCell style={{ width: '8%' }} className='schoolHeaderSurveyPdf'>School Name</TableCell>
                                            <TableCell style={{ width: '4%' }} className='schoolHeaderSurveyPdf'>School ID</TableCell>
                                            {surveyTypeOptions.map(headers => (
                                                <TableCell style={{ width: '3%' }} className='schoolHeaderSurveyPdf'>{headers}</TableCell>
                                            ))}

                                            {role == 'admin' ?

                                                <>
                                                    <TableCell style={{ width: '5%' }} className="schoolHeaderSurveyPdf">Blocks</TableCell>
                                                    <TableCell style={{ width: '3%' }} className="schoolHeaderSurveyPdf">Tupe</TableCell>
                                                    <TableCell style={{ width: '4%' }} className="schoolHeaderSurveyPdf">Closed</TableCell>
                                                </>
                                                : ''
                                            }
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {inData && inData.map((data) => (

                                            <TableRowStyledSurveyPdf>

                                                <TableCell
                                                    // ref={el => {
                                                    //     if (el) {
                                                    //         el.style.setProperty('padding', '4px 10px 10px 10px', 'important');
                                                    //     }
                                                    // }}
                                                    className='schoolBodySurveyPdf'> {data.surveyType}
                                                </TableCell>

                                                <TableCell
                                                    // ref={el => {

                                                    //     if (el) {
                                                    //         el.style.setProperty('padding', '4px 10px 10px 10px', 'important');
                                                    //     }
                                                    // }} 
                                                    className='schoolBodySurveyPdf'>{data.name}
                                                </TableCell>

                                                <TableCell
                                                    // ref={el => {

                                                    //     if (el) {
                                                    //         el.style.setProperty('padding', '4px 10px 10px 10px', 'important');
                                                    //     }
                                                    // }} 
                                                    className='schoolBodySurveyPdf'>{data.ncesId}
                                                </TableCell>

                                                {surveyTypeOptions.map(surveyOptionsheader => (

                                                    <TableCell className='schoolBodySurveyPdf'>
                                                        {Object.keys(data).map(e => (
                                                            <>
                                                                {e == surveyOptionsheader ?
                                                                    data[e] == 1 ?
                                                                        <img className='imageCheckSurveyPdf' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check'></img>
                                                                        : ''
                                                                    : ''}

                                                            </>
                                                        ))}
                                                    </TableCell>
                                                ))}

                                                {role == 'admin' ?

                                                    <>
                                                        <TableCell className='schoolBodySurveyPdf' >
                                                            {data.blockData.length > 0 ?
                                                                <>
                                                                    <span style={{ fontSize: '13px' }} className='imageCheckSurveyPdf'>{data.blockData.sort().join(',')}</span>
                                                                </> : ''}
                                                        </TableCell>

                                                        <TableCell className='schoolBodySurveyPdf'>
                                                            {data.tupe == 0 ? ''
                                                                : <img className='imageCheckSurveyPdf' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check'></img>
                                                            }
                                                        </TableCell>

                                                        <TableCell className='schoolBodySurveyPdf'>
                                                            {data.closeData == 0 ? ''
                                                                : <img className='imageCheckSurveyPdf' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check'></img>
                                                            }
                                                        </TableCell>

                                                    </> : ''}

                                            </TableRowStyledSurveyPdf>

                                        ))}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </>
            ))}
            {isPageLoad ? <div id="pageload" ></div> : ''}
        </>
    )
}

export default SurveyPdf